export default "__VITE_ASSET__CPRY84cD__"